export const mainTitle = {
    title: {
        ARM: "Բարի գալուստ labcare",
        ENG: "Welcome to labcare",
        RUS: "Добро пожаловать в labcare"
    },
    moto: {
        ARM: "Մենք կարող ենք օգնել ձեզ ստանալ ՃՇՄԱՐՏՈՒԹՅՈՒՆԸ ...",
        ENG: "We can help you get THE TRUTH...",
        RUS: "Мы можем помочь вам узнать ИСТИНУ..."
    },

};

export const activitiesTitle = {
    ARM: "մեր գործունեությունը",
    ENG: "our activities",
    RUS: "наша деятельность"
};

export const moto = {
    ARM: "Որակ, վստահություն և փորձ",
    ENG: "Quality, trust and experience",
    RUS: "Качество, доверие и опыт"
};

export const partnersTitle = {
    ARM: "մեր գործընկերները",
    ENG: "our partners",
    RUS: "наши партнеры"
};